import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowRight, Search } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SEOHead } from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center" data-testid="not-found-page">
      <SEOHead title="Page introuvable" description="Cette page n'existe pas ou a été déplacée." path="/404" noindex />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 text-center">
        <div className="w-16 h-16 rounded-2xl bg-[hsl(var(--brand-mint))] flex items-center justify-center mx-auto mb-6"><Search className="h-8 w-8 text-[hsl(var(--primary))]" /></div>
        <p className="text-sm font-medium text-[hsl(var(--primary))] mb-2">Erreur 404</p>
        <h1 className="font-['Space_Grotesk'] text-3xl sm:text-4xl font-bold mb-4">Cette page n'existe pas</h1>
        <p className="text-muted-foreground mb-8">Le lien est peut-être erroné ou la page a été déplacée. Retrouvez nos services, nos villes desservies ou demandez directement un devis gratuit.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link to="/"><Button variant="outline" data-testid="not-found-home"><Home className="h-4 w-4 mr-2" /> Accueil</Button></Link>
          <Link to="/services"><Button variant="outline" data-testid="not-found-services">Nos services</Button></Link>
          <Link to="/devis"><Button className="bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 text-white" data-testid="not-found-devis">Devis gratuit <ArrowRight className="h-4 w-4 ml-2" /></Button></Link>
        </div>
      </div>
    </div>
  );
}
